<template>
    <el-header class="el_head">
        <div class="center">
            <el-row type="flex">
                <el-col :span="24">
                    <router-link to="/">
                        <img class="img" src="./../assets/logo2.png">
                        <div class="logoTxt">Hebe Explorer</div>
                    </router-link>
                    <el-dropdown class="el_dropdown" @command="handleCommand">
            <span class="el-dropdown-link">
              {{$store.state.apiText}} {{$t('l.fhead.block')}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="blocks">{{$t('l.fhead.blocks')}}</el-dropdown-item>
                            <el-dropdown-item command="peers">{{$t('l.fhead.peers')}}</el-dropdown-item>
                            <el-dropdown-item command="generators">{{$t('l.fhead.generators')}}</el-dropdown-item>
                            <el-dropdown-item
                                    v-if="$store.state.apiText=='Hebe'"
                                    command="peersMap"
                            >{{$t('l.fhead.peersMap')}}
                            </el-dropdown-item>
                            <el-dropdown-item
                                    v-if="$store.state.apiText=='Hebe'"
                                    command="peers3d"
                            >{{$t('l.fhead.peers3d')}}
                            </el-dropdown-item>
                            <el-dropdown-item v-if="$store.state.apiText=='Hebe'" command="api">Api</el-dropdown-item>

                            <a target="_blank" href="/#/?type=HEBE">
                                <el-dropdown-item divided>Hebe {{$t('l.fhead.block')}}</el-dropdown-item>
                            </a>
                            <a target="_blank" href="/#/?type=NXT">
                                <el-dropdown-item>Nxt {{$t('l.fhead.block')}}</el-dropdown-item>
                            </a>
                            <a target="_blank" href="/#/?type=Rya">
                                <el-dropdown-item>Rya {{$t('l.fhead.block')}}</el-dropdown-item>
                            </a>
                            <a target="_blank" href="/#/?type=Aie">
                                <el-dropdown-item>Aie {{$t('l.fhead.block')}}</el-dropdown-item>
                            </a>
                            <a target="_blank" href="/#/?type=Actn">
                                <el-dropdown-item>Actn {{$t('l.fhead.block')}}</el-dropdown-item>
                            </a>
                        </el-dropdown-menu>
                    </el-dropdown>
           <el-dropdown class="el_dropdown" @command="lg">
            <span class="el-dropdown-link">
              {{$t('l.fhead')[$store.state.lang]}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
                            <el-dropdown-item command="en-US">English</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown class="el_dropdown" @command="peer">
                             <span class="el-dropdown-link">
                                 {{$t('l.fhead.peer1')}}
                              <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="peer">{{$t('l.fhead.peer2')}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button
                            @click="search"
                            style="float: right;margin-top: 10px;"
                            icon="el-icon-search"
                            circle
                    ></el-button>
                </el-col>
            </el-row>
        </div>

    </el-header>
</template>


<script>
    export default {
        name: "fhead",
        methods: {
            peer(command) {
                this.$router.push("/peer");
            },
            lg(command) {
                this.$i18n.locale = command;
                this.$store.commit("setLang", command);
            },
            handleCommand(command) {
                if (command && command.indexOf("type") == -1) {
                    this.$router.push("/" + command);
                }
            },
            search() {
                this.$prompt(
                    this.$t("l.fhead.prompt.txt"),
                    this.$t("l.fhead.prompt.title"),
                    {
                        confirmButtonText: this.$t("l.fhead.prompt.confirm"),
                        cancelButtonText: this.$t("l.fhead.prompt.cancel")
                    }
                ).then(({value}) => {
                    if (value.indexOf("-") != -1) {
                        this.$router.replace("/account/" + value);
                    } else {
                        if (value.length == 20) {
                            this.$router.replace("/transaction/" + value);
                        } else {
                            this.$router.replace("/block/" + value);
                        }
                    }
                });
            }
        },
        created: function () {
        }
    };
</script>


<style lang="less">
    a {
        text-decoration: none !important;
        color: #606266;
    }

    .el_head {
        background-color: #2196f3 !important;
        box-shadow: 0 1px 0px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24) !important;

        .el-dropdown-link {
            color: #fff;
        }

        .el_dropdown {
            margin-top: 25px;
            margin-left: 20px;
        }

        .img {
            float: left;
            width: 40px;
            margin-top: 10px;
        }

        .logoTxt {
            font-weight: bold;
            font-size: 20px;
            float: left;
            color: #fff;
            margin-top: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/fhead.vue